import { setCookieForDomain, RecentSearchCookie } from 'app/functions';
import cookies from 'js-cookie';

const RECENT_SEARCHES_COOKIE = 'recent-searches-params';
export const setRecentSearchesCookie = (recentSearchesCookiePayload: RecentSearchCookie) => {
  const currentCookie = cookies.get(RECENT_SEARCHES_COOKIE);
  const recentSearches: RecentSearchCookie[] = currentCookie ? JSON.parse(currentCookie) : [];
  recentSearches.unshift(recentSearchesCookiePayload);
  const newCookie = recentSearches.slice(0, 5);
  setCookieForDomain({
    cookieName: RECENT_SEARCHES_COOKIE,
    cookieValue: JSON.stringify(newCookie),
    expirationTime: 365,
  });
};
